import { defineMessages } from 'react-intl'

const scope = `procurify.components.FiltersPopover`

export default defineMessages({
  buttonText: {
    id: `${scope}.buttonText`,
    defaultMessage: 'Filters',
  },
})
